// データを取得するためライブラリアクシオスです
import Request from 'axios'

// wpService、または wordpress として使われます。
const wpClient = () => {
  // .envを確認する。→（https://stg.zatsudan-work.net/zatsudan_adminconsole）
  // const apiEndPoint = process.env.VUE_APP_WP_API_URL || window.origin
  const apiEndPoint = process.env.VUE_APP_WP_API_URL
  //console.log("apiEndPoint:",apiEndPoint)

  //console.log(apiEndPoint)
  // axiosのデフォルトのURLは（https://stg.zatsudan-work.net/zatsudan_adminconsole）
  Request.defaults.baseURL = `${apiEndPoint}/`
  // リクエストのヘッダーを指定する？所です。 jsonを受け取ります。
  const headersDefault = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
  // クレデンシャルと一緒。ヘッダーはJSONを受け入れ、コンテンツタイプはJSON
  const defaultOptions = {
    withCredentials: true,
    headers: {
      // ... は 「スプレッド演算子」です。
      // 配列の中身を[]に入れずに展開できるので、
      // ココにはそのまんま
      // 'Accept': 'application/json',
      // 'Content-Type': 'application/json',
      // が入っています。
      ...headersDefault
    }
  }

  // Add a Request
  // アクシオス の 前処理 で リクエスト する時に実行されます。
  Request.interceptors.request.use(
    config => config,
    // エラーがいくつも返ってくるようにになっている
    error => Promise.reject(error),
  )

  // Add a response.
  // アクシオス の 前処理 で レスを受け取る 時に実行されます。
  Request.interceptors.response.use(
    response => response,
    // エラーがいくつも返ってくるようにになっている
    error => Promise.reject(error),
  )

  return {
    // 変数をすべていれると、こんな感じになります。
    // axios.get(
    //  https://stg.zatsudan-work.net/zatsudan_adminconsole/wp-json/v2/posts/),
    //   {'Accept': 'application/json',
    //    'Content-Type': 'application/json',
    //    'categories': '9',
    //    'per_page': '10'
    //   }),
    get: (url, options = {}) => Request.get(url, {
      ...defaultOptions, ...options
    }),
    post: (url, data, options = {}) => Request.post(url, data, {
      ...defaultOptions, ...options
    }),
    put: (url, data, options = {}) => Request.put(url, data, {
      ...defaultOptions, ...options
    }),
    patch: (url, data, options = {}) => Request.patch(url, data, {
      ...defaultOptions, ...options
    }),
    delete: (url, options = {}) => Request.delete(url, {
      ...defaultOptions, ...options
    }),
  }
}

export default wpClient
